import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

export default store => ({
  path: "student-transfers",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "student-transfers" */ "./components"),
      import(
        /* webpackChunkName: "student-transfers" */ "./modules/StudentTransfersModule"
      ),
    ]).then(([importedModule, module]) => {
      injectReducer(store, { key: module.NAME, reducer: module.default });
      return importedModule.default;
    })
  ),
});
